import React from 'react';
import './ChantierUpdate.css';
import {Button} from 'react-bootstrap';

/**
 * Vue pour modifier ou ajouter un chantier
 * @param {*} props props
 * @return {JSX}
 */
function ChantierUpdateView(props) {
  return (
    <form className="form chantier-border" style={{border: 'none'}} onSubmit={props.handleSubmit}>
      <span className="employe-close" onClick={() => props.closeModal()} style={{marginRight: '15px', marginTop: '5px'}}>
                &times;
      </span>
      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        {props.isUpdate ? <h1 style={{color: 'white'}}> Modifier un projet</h1> : <h1 style={{color: 'white'}}> Ajouter le projet</h1>}
      </div>
      <div className="form-group">
        <label style={{color: 'white'}} htmlFor="name">Nom du client:</label>
        <input
          className="form-control"
          name="client_name"
          value={props.form.client_name == null ? '' : props.form.client_name}
          onChange={props.handleChange} />
      </div>
      <div className="form-group">
        <label style={{color: 'white'}} htmlFor="adresse">Adresse:</label>
        <input
          className="form-control"
          name="name"
          value={props.form.name == null ? '' : props.form.name}
          onChange={props.handleChange} />
      </div>
      {props.error !== '' && (
        <span className="error">{props.error}</span>
      )}
      <div className="form-group">
        <label style={{color: 'white'}} htmlFor="phone">Téléphone:</label>
        <input
          className="form-control"
          name="phone"
          value={props.form.phone == null ? '' : props.form.phone}
          onChange={props.handleChange} />
      </div>
      <div className="form-group">
        <label style={{color: 'white'}} htmlFor="contrat"> # Contrat:</label>
        <input
          className="form-control"
          name="contrat"
          value={props.form.contrat == null ? '' : props.form.contrat}
          onChange={props.handleChange} />
      </div>
      <Button
        color="white"
        type='submit'
        size="lg"
        style={{
          color: 'white',
          fontSize: 'calc(10px + 2vmin)',
          backgroundColor: '#363E46',
          border: 'none',
          width: '100%',
        }}
        onClick={props.handleSubmit}>
        Enregistrer
      </Button>
    </form>
  );
}

export default ChantierUpdateView;
